module.exports = __webpack_public_path__ + "img/tc2.34e942e0.png";